import decisionTypeList from "./decision-type";
import timePeriodList from "./time-period";


export default [...timePeriodList, ...decisionTypeList];